module.exports = __webpack_public_path__ + "img/hr-rock-big-03.41aae44e.png";